import React from "react";
import PropTypes from "prop-types";
import Highlighter from "react-highlight-words";
import { css } from "react-emotion";
import { ClickOutsideListener, Trans } from "components";
import Waypoint from "react-waypoint";
import { normalize, mergeDedupe } from "utilities";
import cuid from "cuid";
import { withTranslated } from "components/HOC";

const ID = cuid();

class ListSearchBox extends React.Component {
  constructor() {
    super();
    this.initialState = {
      open: false,
      fetching: false,
      value: "",
      items: [],
      error: null,
      searchWords: [],
      page: 1,
      fetchingNew: false,
      lastPage: false
    };
    this.state = this.initialState;
    this.timeout = null;
  }

  open = () => {
    this.setState(p => {
      if (p.value.length > 0) return { open: true };
      return null;
    });
  };
  close = () => {
    this.setState({ open: false });
  };

  scrollTop = () => {
    const wrapper = document.getElementById(ID);
    if (wrapper) {
      wrapper.scrollTop = 0;
    }
  };

  loadPage = async () => {
    const page = this.state.page + 1;
    const val = this.state.value;
    this.setState({ fetchingNew: true });
    try {
      const payload = await this.props.searchFunc(val, page);
      this.setState(p => {
        const merged = [...p.items, ...payload.results];
        const normalized = normalize(merged);
        return {
          items: mergeDedupe(normalized.ids).map(id => normalized.elements[id]),
          page: p.page + 1,
          fetchingNew: false,
          lastPage: payload.next === null
        };
      });
    } catch (error) {
      this.setState({ fetchingNew: false, lastPage: true });
    }
  };

  handleSearch = ({ target }) => {
    clearTimeout(this.timeout);
    const val = target.value;
    if (val === "") {
      this.setState({ ...this.initialState });
      return;
    }
    this.setState({
      open: true,
      fetching: true,
      value: val,
      searchWords: val.split(" "),
      page: 1
    });
    this.timeout = setTimeout(async () => {
      try {
        const payload = await this.props.searchFunc(val, this.state.page);
        this.scrollTop();
        this.setState({
          fetching: false,
          items: payload.results,
          error: null,
          lastPage: payload.next === null
        });
      } catch ({ error, isCanceled }) {
        if (isCanceled) return;
        this.setState(() => ({
          fetching: false,
          error: error.$any || this.props.t("Błąd wyszukiwania")
        }));
      }
    }, 200);
  };

  render() {
    const {
      fetching,
      value,
      items,
      error,
      searchWords,
      fetchingNew
    } = this.state;
    const {
      clickCallback,
      children,
      keyField,
      disabledItems,
      wide,
      t
    } = this.props;

    const styles = {
      width: wide ? "100%" : 410
    };

    return (
      <div style={styles}>
        <div className="subnav-searcher-field">
          <input
            type="search"
            placeholder={t("Wyszukaj produkty")}
            className="ignore-react-onclickoutside"
            value={value}
            onClick={this.open}
            onChange={this.handleSearch}
          />
          {fetching && <div className="loader" />}
          {this.state.open && (
            <Popover
              close={this.close}
              items={items}
              error={error}
              keyField={keyField}
              loadPage={this.loadPage}
              fetchingNew={fetchingNew}
              searchWords={searchWords}
              disabledItems={disabledItems}
              clickCallback={clickCallback}
            >
              {children}
            </Popover>
          )}
        </div>
      </div>
    );
  }
}

ListSearchBox.propTypes = {
  disabledItems: PropTypes.arrayOf(PropTypes.number).isRequired,
  clickCallback: PropTypes.func.isRequired,
  searchFunc: PropTypes.func.isRequired,
  keyField: PropTypes.string.isRequired,
  children: PropTypes.any
};

const Popover = ({
  close,
  items,
  error,
  searchWords,
  clickCallback,
  keyField,
  disabledItems,
  children,
  loadPage,
  fetchingNew
}) => {
  let content;
  if (children) {
    content = children({ items });
  } else if (items.length === 0) {
    content = (
      <div className="searcher_results-list--result"><Trans>Brak wyników.</Trans></div>
    );
  } else if (error) {
    content = <div className="searcher_results-list--result">{error}</div>;
  } else {
    content = (
      <React.Fragment>
        {items.map(item => {
          const disabled = disabledItems.find(el => el === item.id);
          const disabledClass = disabled ? itemDisabled : "";
          const callback = disabled ? undefined : () => clickCallback(item);

          return (
            <div
              className={`searcher_results-list--result ${disabledClass}`}
              key={item.id}
              onClick={callback}
            >
              <Highlighter
                highlightClassName={css`
                  font-weight: 600;
                  font-style: normal;
                `}
                className="result_match--sugestion"
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={item[keyField]}
              />
            </div>
          );
        })}
        <Waypoint bottomOffset="-200px" onEnter={loadPage} />
        {fetchingNew && (
          <div className="searcher_results-list--result">
            <Trans>Wczytywanie</Trans>...
          </div>
        )}
      </React.Fragment>
    );
  }

  return (
    <ClickOutsideListener close={close}>
      <div
        className="searcher_results-list--wrapper"
        id={ID}
        style={{ overflowY: "auto", maxHeight: 400 }}
      >
        {content}
      </div>
    </ClickOutsideListener>
  );
};

Popover.propTypes = {
  disabledItems: PropTypes.arrayOf(PropTypes.number).isRequired,
  clickCallback: PropTypes.func.isRequired,
  searchWords: PropTypes.array.isRequired,
  keyField: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  close: PropTypes.func.isRequired,
  error: PropTypes.string,
  children: PropTypes.any
};

const itemDisabled = css`
  background-color: #efeeec;
  :hover {
    cursor: not-allowed;
  }
`;

export default withTranslated(ListSearchBox);


// WEBPACK FOOTER //
// ./src/components/ListSearchBox.jsx